import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import TheLogin from "@/components/Common/TheLogin";
import TheTeams from "@/components/Admin/TheTeams";
import TheTeam from "@/components/Admin/TheTeam";
import ThePrompt from "@/components/Admin/ThePrompt";
import TheHackathon from "@/components/Admin/TheHackathon";

/** Заголовок вкладки, если у маршрута нет meta.title (редиректы, catch-all) */
const DEFAULT_DOCUMENT_TITLE = "HachApi";

const router = createRouter({
	history: createWebHistory(),
	routes: [
		{
			path: "/",
			component: TheLogin,
			meta: {
				title: "Авторизация",
				layout: "login",
				auth: false,
			},
			name: "login",
		},

		{
			path: "/teams",
			component: TheTeams,
			meta: {
				title: "Команды",
				layout: "admin",
				auth: true,
			},
			name: "teams",
		},

		{
			path: "/about",
			component: TheHackathon,
			meta: {
				title: "О мероприятии",
				layout: "admin",
				auth: true,
			},
			name: "hackathon",
		},

		{
			path: "/team/:id/:task?",
			component: TheTeam,
			meta: {
				title: "Команда",
				layout: "admin",
				auth: true,
			},
			name: "team",
		},

		{
			path: "/prompt/:id?",
			component: ThePrompt,
			meta: {
				title: "Промпт",
				layout: "admin",
				auth: true,
			},
			name: "prompt",
		},

		{
			path: "/:notFound(.*)",
			redirect: "/",
		},
	],

	linkActiveClass: "active",
	linkExactActiveClass: "active",
});

router.beforeEach((to, _from, next) => {
	const title = to.meta?.title;
	document.title = title != null && title !== "" ? title : DEFAULT_DOCUMENT_TITLE;

	const requireAuth = to.meta?.auth === true;
	const isAuth = store.getters["authModule/isAuth"];

	// Авторизованный пользователь на "/" → сразу к списку команд
	if (to.path === "/" && isAuth) {
		next("/teams");
		return;
	}

	if (!requireAuth || isAuth) {
		next();
		return;
	}

	next("/");
});

export default router;
